export default function header() {
  $(function() {
    $('.menu').on('click', function() {
      $('.menu').toggleClass('active')
      $('.select-container').fadeToggle()
      $('.navegation').fadeToggle()
    })
  })
}
